import { Formik } from "formik";
import omitDeep from "omit-deep-lodash";
import { useTranslation } from "react-i18next";
import { BiCheck, BiChevronLeft, BiTrash } from "react-icons/bi";
import { useNavigate } from "react-router";
import Card from "shared/components/Card";
import EmailTemplateVariablesTable from "shared/components/EmailTemplateVariablesTable";
import Header from "shared/components/Header";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SCREENS } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import IconUploadField from "../IconUploadField";
import validation from "./validation";
import { Divider } from "antd";

const Detail = ({ onSubmit, data, cancel }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.EMAIL_TEMPLATE);
  const navigate = useNavigate();
  const DETAIL = t("DETAIL", { returnObjects: true });
  const FORM = t("FORM", { returnObjects: true });

  return (
    <Formik
      initialValues={omitDeep(data, "__typename")}
      onSubmit={onSubmit}
      validationSchema={validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
      )}
    >
      {({ handleSubmit, values, setFieldValue, ...formProps }) => [
        <Header
          key={"header"}
          title={DETAIL.HEADER?.TITLE}
          subtitle={DETAIL.HEADER?.ACTION}
          actions={[
            {
              text: DETAIL.HEADER?.DISCARD,
              onClick: cancel,
              type: "primary--outlined",
              icon: <BiChevronLeft size={20} />,
            },
            {
              text: DETAIL.HEADER?.DELETE,
              onClick: () =>
                navigate(
                  `${SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.DELETE.path}/${data.id}`,
                ),
              type: "danger--outlined",
              icon: <BiTrash size={20} />,
            },
            {
              text: DETAIL.HEADER?.SAVE,
              onClick: handleSubmit,
              type: "primary",
              icon: <BiCheck size={20} />,
            },
          ]}
        />,
        <Card key="card" type={"simple"}>
          <div className="email-template-form__active-row d-flex flex--column gap-8">
            <Input
              type="switch"
              label={FORM.ACTIVE_MODEL}
              checked={values.active !== false}
              onChange={(checked) => setFieldValue("active", checked)}
            />
            <p className="email-template-variables-hint">
              {FORM.ACTIVE_MODEL_HELP}
            </p>
          </div>
          <div className="grid--2">
            <Input
              label={FORM.LABEL}
              placeholder={FORM.LABEL}
              {...bindInputProps({ name: "label", ...formProps, values })}
            />

            <Input
              label={FORM.DESCRIPTION}
              placeholder={FORM.DESCRIPTION}
              {...bindInputProps({
                name: "description",
                ...formProps,
                values,
              })}
            />
            <IconUploadField
              label={FORM.ICON}
              buttonLabel={FORM.UPLOAD_ICON}
              uploadingLabel={FORM.UPLOADING}
              removeLabel={FORM.REMOVE_ICON}
              uploadErrorMessage={FORM.UPLOAD_ICON_ERROR}
              iconValue={values.icon}
              setFieldValue={setFieldValue}
            />
          </div>
          <Divider />
          <Input
            label={FORM.SUBJECT}
            placeholder={FORM.SUBJECT}
            {...bindInputProps({ name: "subject", ...formProps, values })}
          />
          <div className="mt-16">
            <Input
              type="richText"
              label={FORM.BODY}
              value={values.body}
              onChange={(val) => setFieldValue("body", val)}
              placeholder={FORM.BODY_PLACEHOLDER}
            />
          </div>
          <Divider />
          <div className="mt-16 d-flex flex--column gap-8">
            <span className="input__label">{FORM.VARIABLES_TITLE}</span>
            <EmailTemplateVariablesTable
              columns={FORM.VARIABLES_TABLE?.COLUMNS}
              rows={FORM.VARIABLES_TABLE?.ROWS}
            />
          </div>
        </Card>,
      ]}
    </Formik>
  );
};

export default Detail;
